import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストインターセプター
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('meeting_api_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// レスポンスインターセプター
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// AI Advice API
export const getAiAdvice = async (data: {
  recording_id: string;
  manager_id: number;
  last_segment_id: number;
  meeting_goal?: string;
  previous_advices?: string[];
  elapsed_seconds?: number;
  scheduled_duration_minutes?: number;
}) => {
  const response = await api.post('/meeting/ai-advice', data);
  return response.data;
};

// AI Evaluation API
export const getAiEvaluation = async (data: {
  recording_id: string;
  last_segment_id: number;
  previous_evaluation?: {
    positive: number;
    understanding: number;
    activity: number;
  };
}) => {
  const response = await api.post('/meeting/ai-evaluation', data);
  return response.data;
};

// MTG Check API
export const getMtgCheck = async (data: {
  recording_id: string;
  template_id: number;
  last_segment_id: number;
  meeting_goal?: string;
  existing_checks?: Array<{ index: number; note: string }>;
}) => {
  const response = await api.post('/meeting/mtg-check', data);
  return response.data;
};

// Next Actions API
export const getNextActions = async (data: {
  recording_id: string;
  last_segment_id: number;
  meeting_goal?: string;
  existing_actions?: string[];
}) => {
  const response = await api.post('/meeting/next-actions', data);
  return response.data;
};

// MTG Check + TODO + AI Evaluation (Combined API)
export const getMtgCheckTodo = async (data: {
  recording_id: string;
  template_id: number;
  last_segment_id: number;
  meeting_goal?: string;
  existing_todos?: string[];
}) => {
  const response = await api.post('/meeting/mtg-check-todo', data);
  return response.data;
};

// Generate Minutes API
export const generateMinutes = async (data: {
  recording_id: string;
  token?: string;
  meeting_name?: string;
  meeting_goal?: string;
  template_name?: string;
  mtg_checks?: Array<{ text: string; completed: boolean; note?: string }>;
  todos?: string[];
  ai_evaluation?: { positive: number; understanding: number; activity: number };
  ai_advices?: Array<{ manager_name: string; text: string }>;
}) => {
  const response = await api.post('/meeting/generate-minutes', data);
  return response.data;
};

export default api;
